import React, { Component } from 'react';
import PrismicReact from 'prismic-reactjs';

class Footer extends Component {
  state = {
    doc: null,
		notFound: null
  }

  componentWillMount() {
    this.fetchFooter(this.props);
  }

  componentWillReceiveProps(props) {
    this.fetchFooter(props);
  }

  componentDidUpdate() {
    this.props.prismicCtx.toolbar();
  }

  fetchFooter(props) {
    if (props.prismicCtx) {

			return props.prismicCtx.api.getSingle('footer')
				.then((doc) => {
					if (doc) {
          	this.setState({ doc });
        	} else {
          	this.setState({ notFound: !doc });
        	}
			});
    }
  }

	render() {
	  if (this.state.doc) {
	    return (
	        <div
					className="row footer d-flex justify-content-center">
						<div
							className="
							d-flex
							flex-wrap
							element_list
							justify-content-between
							col-lg-8
							col-md-12
							px-0"
						>

							{this.state.doc.data.fields.map(field => {
								return (
									<div key={field.content[0].text} className="element p-0 mx-3">
										{PrismicReact.RichText.render(field.content)}
									</div>
								);
							})}

						</div>
					</div>
	    );
	  } else {
			return <div></div>;
		}
	}
}

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer.js